<template>
	<main class="new-server-error">
		<div class="new-server-error__content new-layout-container">
			<div class="new-server-error__badge" aria-hidden="true">Ops!</div>

			<h1>{{translation.serverErrorTitle}}</h1>
			<p>{{translation.serviceUnavailable}}</p>
			<a href="/calendar">{{translation.backToSite}}</a>

			<img
				class="new-server-error__logo"
				src="/static/logo_pt.png"
				alt="Blumar Congressos e Eventos"
			>
		</div>
	</main>
</template>

<script>
import { translate } from '../../assets/translations';

export default {
	computed: {
		translation() {
			return translate(this.$store.state.language).globalErrors;
		},
	},
	metaInfo: {
		title: 'Serviço indisponível',
	},
};
</script>

<style scoped lang="scss">
.new-server-error {
	display: flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	min-height: 55vh;
	padding: 70px 0 90px;
	background: #ffffff;
}

.new-server-error__content {
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
}

.new-server-error__badge {
	display: flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	width: 157px;
	min-height: 72px;
	border-radius: 5px;
	color: #173d64;
	font-size: 42px;
	font-weight: 700;
	line-height: 1;
}

.new-server-error h1 {
	margin: 28px 0 6px;
	color: #4c4b4b;
	font-size: 27px;
	font-weight: 700;
	line-height: 32px;
	text-transform: uppercase;
}

.new-server-error p {
	margin: 0 0 4px;
	color: #5a5a5a;
	font-size: 17px;
	line-height: 24px;
}

.new-server-error a {
	color: #2abf9f;
	font-size: 18px;
	font-weight: 700;
	line-height: 24px;
	text-decoration: none;
	text-transform: uppercase;
}

.new-server-error a:hover,
.new-server-error a:focus-visible {
	color: #0b3a52;
	text-decoration: underline;
}

.new-server-error__logo {
	display: block;
	width: 175px;
	height: auto;
	margin-top: 32px;
}

@media (max-width: 600px) {
	.new-server-error {
		min-height: 60vh;
		padding: 60px 0 75px;
	}

	.new-server-error__badge {
		width: 140px;
		min-height: 64px;
		font-size: 36px;
	}

	.new-server-error h1 {
		font-size: 22px;
		line-height: 27px;
	}

	.new-server-error p,
	.new-server-error a {
		font-size: 15px;
		line-height: 21px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/errors/ServerError.vue